import { useMemo } from 'react';
import type { ProductDetail } from '../../domain/models/ProductDetail';
import type { ProductCustomization } from '@/features/customization/domain/models/ProductCustomization';
import { toPdpEffectiveProductVm } from '../viewModels/pdp.vm';

export function usePdpPresentation(
  productDetail: ProductDetail | null,
  customization: ProductCustomization | null
) {
  return useMemo(
    () => (productDetail ? toPdpEffectiveProductVm(productDetail, customization) : null),
    [productDetail, customization]
  );
}
